import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useTeceoStyles from '../../../../../../../useTeceoStyles';
import { CatalogTestIds } from '../../../../../../../utils/testIds/catalog.testIds';
import { UsedInOfflineMode } from '../../../../../../offline/types/UsedInOfflineMode';
import { Catalog } from '../../../../../catalog.types';
import CatalogCardBase from '../CatalogCardBase';
import { CatalogActionsProps } from './CatalogActions';

interface CatalogCardContentProps extends UsedInOfflineMode {
  catalog: Catalog;
  actions?: CatalogActionsProps[];
  isUploadingCover?: boolean;
}

const CatalogCardContent = ({ catalog, actions, isUploadingCover }: CatalogCardContentProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const location = useLocation();

  return (
    <Link
      test-id={`${CatalogTestIds.CATALOG_CARD_LINK_PREFIX}${catalog.id}`}
      className={teceoClasses.link}
      to={{
        pathname: `/catalogs/${catalog.id}/products`,
        state: { originUrl: location.pathname, filters: location.search },
      }}
    >
      <CatalogCardBase catalog={catalog} actions={actions} isUploadingCover={isUploadingCover} />
    </Link>
  );
};

export default memo(CatalogCardContent);
